<template>
  <a-modal
    ref="createModal"
    title="工艺路线"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    okText="保存"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="top-line">
      <a-button @click="addLine()" type="primary">新增行</a-button>
      <div class="top-line-right">工艺路线：
        <a-select v-model="routingCode" @change="idOnChange">
          <a-select-option v-for="(item) in routingList" :key="item.id">{{ item.routingCode }}</a-select-option>
        </a-select>
      </div>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="tableList"
      :loading="pageParams.tableLoading"
      :pagination="false"
      row-key="indexId"
      :scroll="{ x: 800, y: 260 }"
    >
      <span slot="operationSeqNumTitle">
        <i class="toRequired">*</i>工序号
      </span>
      <span slot="operationCodeTitle">
        <i class="toRequired">*</i>工序编码
      </span>
      <span slot="operationTypeTitle">
        <i class="toRequired">*</i>工序类型
      </span>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.dataIndex === 'operation'">
            <a @click="handleDelete(tableList, record)">删除</a>
          </span>
          <span v-else-if="item.type === 'select'">
            <global-select
              :value.sync="record[item.dataIndex]"
              :selectData="setArray(item.dataList)"
              :selectItem="{ value: item.value, label: item.label }"
              :allowClear="false"
              @change="selectChange(record, item.dataIndex, item.dataList)"
            />
          </span>
          <span v-else-if="item.type === 'input'">
            <a-input v-model="record[item.dataIndex]" :disabled="item.disabled" />
          </span>
          <span v-else-if="item.type === 'inputNumber'">
            <a-input-number @change="inputNumberChange(record,item.dataIndex)" v-model="record[item.dataIndex]" :min="0" />
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </a-table>
    <!-- 底部分页按钮 -->
    <Page v-show="false" ref="page" :pageParams.sync="pageParams" @getList="getList" />
  </a-modal>
</template>

<script>
import { apiBomOperationFindList, apiBomProdLineAssignEditBomRoutingProduct, apiBomRoutingHeaderFindList, apiBomRoutingHeaderId } from '@/api/mes/basedata/productProductionLine'

export default {
  props: {},
  data () {
    return {
      prodLineAssignId: '',
      isLoadTemplate: false,
      loadIds: [], // 菜单加载的所有Id
      pageParams: {
        automatic: false,
        pageUrl: '/bom/bomProdLineAssign/bomRoutingProductList',
        tableLoading: false
      },
      // 查询参数
      queryParams: {
        prodLineAssignId: undefined
      },
      routingCode: "",
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '工序号',
          dataIndex: 'operationSeqNum',
          scopedSlots: { customRender: 'operationSeqNum', title: "operationSeqNumTitle" },
          width: 150,
          type: "inputNumber"
        },
        {
          // title: '工序编码',
          dataIndex: 'operationId',
          scopedSlots: { customRender: 'operationId', title: "operationCodeTitle" },
          width: 150,
          type: "select",
          dataList: 'operationCodeList',
          value: 'selectedValue',
          label: 'label'

        },
        {
          title: '工序说明',
          dataIndex: 'operationDesc',
          scopedSlots: { customRender: 'operationDesc' },
          width: 150,
          type: "input",
          disabled: true
        },
        {
          // title: '工序类型',
          dataIndex: 'operationType',
          scopedSlots: { customRender: 'operationType', title: "operationTypeTitle" },
          width: 150,
          type: "select",
          dataList: 'operationTypeList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          title: '工时(分钟/套)',
          dataIndex: 'workingHours',
          scopedSlots: { customRender: 'workingHours' },
          width: 150,
          type: "inputNumber"
        },
        {
          title: '配置人数',
          dataIndex: 'personnelAllocation',
          scopedSlots: { customRender: 'personnelAllocation' },
          width: 150,
          type: "inputNumber"
        },
        {
          title: '产能效率(分钟/套/人)',
          dataIndex: 'efficiency',
          scopedSlots: { customRender: 'efficiency' },
          width: 170,
          type: "inputNumber"
        },
        {
          title: '产能(套/时)',
          dataIndex: 'unitCapacity',
          scopedSlots: { customRender: 'unitCapacity' },
          width: 150,
          type: "inputNumber"
        },
        {
          title: '操作',
          width: 60,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      tableList: [],
      operationCodeList: [], // 工序编码
      operationTypeList: [], // 工序类型
      routingList: [], // 工艺路线
      deleteList: [],
      lineData: null
    }
  },
  created () {
    this.getLookupList('MES_OPERATION_TYPE', 'operationTypeList')
  },
  mounted () {
  },
  methods: {
    // 工序号
    inputNumberChange (record, dataIndex) {
      if (dataIndex === 'workingHours' || dataIndex === 'personnelAllocation') {
        if (record.workingHours && record.personnelAllocation) { // 工时、配置人数
          record.efficiency = this.$parseFloatToFixed(Number(record.workingHours) / Number(record.personnelAllocation), 6) // 产能效率
        }
      }
      if (dataIndex === 'workingHours' || dataIndex === 'personnelAllocation' || dataIndex === 'efficiency') { // 工时、配置人数
        if (record.efficiency) { // 产能效率
          record.unitCapacity = this.$parseFloatToFixed(60 / Number(record.efficiency), 6) // 产能
        }
      }
    },
    show (obj) {
      this.isLoadTemplate = false
      this.lineData = obj
      this.queryParams.prodLineAssignId = obj.id
      this.prodLineAssignId = obj.id
      this.visible = true
      this.inventOrgValueOnChange(obj.organizationCode)
      this.getOperationCodeList()
      this.$nextTick(() => {
        this.$refs.page.getFirstPage(this.queryParams)
      })
    },
    /** 查询列表 */
    getList (data) {
      data.forEach((element, index) => {
        element.indexId = index + 1
      });
      this.tableList = data;
      this.loadIds = [...data];
    },
    // 工艺路线
    idOnChange (val) {
      this.isLoadTemplate = true;
      this.deleteList = this.loadIds
      this.pageParams.tableLoading = true
      apiBomRoutingHeaderId(val).then(res => {
        const arr = res.data && res.data.bomRoutingLineDtoList || []
        arr.forEach((element, index) => {
          element.indexId = index + 1
          element.prodLineAssignId = this.prodLineAssignId
          delete element.id
          delete element.routingId
        });
        this.tableList = arr
        this.pageParams.tableLoading = false
      })
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.tableList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        operationSeqNum: (Number(indexId) + 1) * 10,
        operationCode: "",
        operationDesc: "",
        operationType: "",
        workingHours: "",
        personnelAllocation: "",
        efficiency: "",
        unitCapacity: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.tableList = arr
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          const isLT = this.isLoadTemplate;
          if (record.id && !isLT) {
            this.deleteList.push(record)
          }
          arr.splice(index, 1);
        }
      });
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
      this.isLoadTemplate = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.tableList.length; i++) {
        if (!this.tableList[i].operationCode || !this.tableList[i].operationType) {
          this.$message.warning('必填项不能为空')
          flag = true
          return
        }
        if (!this.tableList[i].operationSeqNum || Number(this.tableList[i].operationSeqNum) <= 0) {
          this.$message.warning('工序号 不能为空且需大于0')
          flag = true
          return
        }
          if ((this.tableList[i].workingHours || this.tableList[i].workingHours === 0) && Number(this.tableList[i].workingHours) <= 0) {
          this.$message.warning('工时(分钟) 需大于0')
          flag = true
          return
        }
         if ((this.tableList[i].personnelAllocation || this.tableList[i].personnelAllocation === 0) && Number(this.tableList[i].personnelAllocation) <= 0) {
          this.$message.warning('配置人数 需大于0')
          flag = true
          return
        }
        if ((this.tableList[i].efficiency || this.tableList[i].efficiency === 0) && Number(this.tableList[i].efficiency) <= 0) {
          this.$message.warning('产能效率(套/分钟) 需大于0')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      const params = {
        ...this.lineData,
        deleteList: this.deleteList,
        updateList: this.tableList
      }
      apiBomProdLineAssignEditBomRoutingProduct(params).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.routingCode = ""
      this.routingList = []
      this.deleteList = []
      this.tableList = []
    },
    selectChange (record, dataIndex, dataList) {
      console.log(record, dataIndex, dataList)
      if (dataIndex === "operationId") {
        const selectItem = this[dataList].find(item => {
          return item.selectedValue === record[dataIndex]
        })
        record.operationDesc = selectItem.realValue
        record.operationCode = selectItem.label
      }
    },
    setArray (arr) {
      return this[arr]
    },
    inventOrgValueOnChange (val) {
      apiBomRoutingHeaderFindList({ organizationCode: val, isStandardRoutingFlag: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.routingList = res
        }
      })
    },
    // 工序编码
    getOperationCodeList () {
      apiBomOperationFindList({ organizationCode: this.lineData.organizationCode }).then(res => {
        this.operationCodeList = res.rows
      })
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
input{
  width: 130px !important;
}
/deep/.ant-input-number{
  width: 130px !important;
}
/deep/.ant-select{
  width: 130px !important;
}
.top-line{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top-line-right{
  display: flex;
  align-items: center;
}
</style>
